import { OperationalCountryInterface } from "./OperationalCountry";
import { WebshopDesignInterface } from "./Webshop";
import { MixtureChooseEnum } from "./Mixture";

export enum MIX_MARKUP_ENUM {
  MARKUP = "Markup",
  DISCOUNT = "Discount",
}

export enum OPERATIONAL_WEBSHOP_STATUS {
  ACTIVE = "ACTIVE",
  BLOCKED = "BLOCKED",
}

export interface MixMarkupInterface {
  id: number;
  value: number;
  tenantId: number;
  type: MIX_MARKUP_ENUM;
}

export interface TenantInterface {
  id: number;
  name: string;
  label: string | null;
  contactEmail: string;
  phone: string;
  countryId: number;
  iposId: number;
  mixMarkups: MixMarkupInterface[] | [];
}

export interface TenantCredentialsInterface {
  id: number;
  domain: string;
  contactEmail: string;
  phone: string;
  countryId: number;
  iposId: number;
  status: OPERATIONAL_WEBSHOP_STATUS;
  linkRedirect: string;
  tenantId: number;
  webshopDesigns: WebshopDesignInterface[];
  tenant: TenantInterface;
  token: string;
  country: OperationalCountryInterface;
}

export interface TenantState {
  data: {
    credentials: TenantCredentialsInterface | null;
  };
}

export interface SetTenantStateActionPayload {
  credentials: TenantCredentialsInterface;
}

export interface CreateMixCondimentInterface {
  id: number;
  parts: number;
  percentage: number;
  weight: number;
}

export interface CreateMixPlatformInterface {
  name: string;
  numberOfGlasses: number;
  weight: number;
  condiments: CreateMixCondimentInterface[];
  categoryId: number;
  token: string;
  receipeType: MixtureChooseEnum;
}
